import React from 'react';
import { Helmet } from 'react-helmet-async';
import CommonHeader from '../Components/Headers/CommonHeader.jsx';
import ChatBot from '../Components/ChatBot/ChatBot.jsx';

export default function ChatBotPage() {
  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: AI Assistant</title>
        <meta name="description" content="Chat with DISGENET AI Assistant." />
      </Helmet>
      <CommonHeader />
      <ChatBot />
    </React.Fragment>
  );
}
